import React from 'react';
import dayjs from 'dayjs';
import './PremiumAppointmentDetailView.scss';
import { FaCalendarAlt, FaIdCard, FaBuilding, FaPhone, FaEnvelope, FaClock, FaMedal, FaUser, FaInfoCircle, FaSwimmer, FaVenusMars, FaCreditCard, FaBan, FaUsers, FaExchangeAlt } from 'react-icons/fa';

const PremiumAppointmentDetailView = ({ appointmentDetail }) => {
    if (!appointmentDetail) return null;

    const isClub = appointmentDetail.reservationType === 'Club' || appointmentDetail.blockSource === 'Club';
    const isBlocked = appointmentDetail.reservationType === 'Blocked' || ['Maintenance', 'PublicEducation', 'PublicEducationCourse'].includes(appointmentDetail.blockSource);
    const isCapacity = appointmentDetail.reservationType === 'CapacitySummary';
    const isIndividual = !isClub && !isBlocked && !isCapacity;

    const facilityStr = `${appointmentDetail.sportTypeName || ''} ${appointmentDetail.facilityName || ''} ${appointmentDetail.regionName || ''}`.toLowerCase();
    const isFreeFitness = String(appointmentDetail.programType || '').toLowerCase() === 'fitness'
        && appointmentDetail.creditsUsed != null && Number(appointmentDetail.creditsUsed) === 0
        && !Number(appointmentDetail.cardMembershipId || 0);
    const isPool = facilityStr.includes('havuz') || facilityStr.includes('yüzme');

    const renderRow = (label, value, icon, isHighlight = false) => {
        if (!value || value === '-') return null;
        return (
            <div className={`appointment-info-row${isHighlight ? ' appointment-info-row--highlight' : ''}`}>
                <div className="appointment-info-label">
                    <span style={{ color: 'var(--arc-text-muted)' }}>{icon}</span>
                    <span>{label}</span>
                </div>
                <div className="appointment-info-value">
                    {value}
                </div>
            </div>
        );
    };

    const TopCard = () => {
        if (isClub) {
            // Multi-club view
            const clubs = appointmentDetail.clubSlotDetails;
            if (clubs && clubs.length > 0) {
                return (
                    <div className="appointment-clubs" style={{ marginBottom: '20px' }}>
                        <div className="appointment-summary-card" style={{
                            padding: '14px 16px',
                            background: 'var(--arc-success-subtle)',
                            borderRadius: '12px 12px 0 0',
                            border: '1px solid rgba(16, 185, 129, 0.25)',
                            borderBottom: 'none',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px'
                        }}>
                            <div style={{
                                width: '40px', height: '40px', borderRadius: '10px',
                                background: 'var(--arc-success)', color: 'white',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontSize: '1.2rem', boxShadow: '0 2px 4px rgba(16, 185, 129, 0.3)'
                            }}>
                                <FaMedal />
                            </div>
                            <div>
                                <div style={{ fontWeight: 700, fontSize: '1.05rem', color: 'var(--arc-success-text)' }}>
                                    Bu Saatteki Kulüpler ({clubs.length})
                                </div>
                                <div style={{ fontSize: '0.8rem', color: 'var(--arc-success-text)', opacity: 0.85, fontWeight: 500 }}>
                                    Kulüp Saat Atamaları
                                </div>
                            </div>
                        </div>
                        <div style={{
                            border: '1px solid rgba(16, 185, 129, 0.25)',
                            borderRadius: '0 0 12px 12px',
                            overflow: 'hidden'
                        }}>
                            {clubs.map((club, idx) => {
                                const paid = club.isPaid || club.status === 'Confirmed';
                                return (
                                    <div className="appointment-club-row" key={club.clubApplicationId || idx} style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        padding: '14px 16px',
                                        borderBottom: idx < clubs.length - 1 ? '1px solid var(--arc-border-subtle)' : 'none',
                                        background: idx % 2 === 0 ? 'var(--arc-surface)' : 'var(--arc-surface-subtle)',
                                        transition: 'background 0.2s'
                                    }}>
                                        <div className="appointment-club-identity" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                            <div className="appointment-club-number" style={{
                                                width: '36px', height: '36px', borderRadius: '50%',
                                                background: paid ? 'linear-gradient(135deg, #10b981, #059669)' : 'linear-gradient(135deg, #f59e0b, #d97706)',
                                                color: 'white',
                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                fontSize: '0.85rem', fontWeight: 700,
                                                boxShadow: `0 2px 4px ${paid ? 'rgba(16,185,129,0.25)' : 'rgba(245,158,11,0.25)'}`
                                            }}>
                                                {idx + 1}
                                            </div>
                                            <div className="appointment-club-copy">
                                                <div style={{ fontWeight: 600, fontSize: '0.9rem', color: 'var(--arc-text-primary)' }}>
                                                    {club.clubName}
                                                    {(!club.clubName.includes('Kulüb')) ? ' Kulübü' : ''}
                                                </div>
                                                <div className="appointment-club-meta" style={{ fontSize: '0.78rem', color: 'var(--arc-text-secondary)', marginTop: '2px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                    {club.taxNumber && <span>VKN: {club.taxNumber}</span>}
                                                    {club.personCount > 0 && (
                                                        <span style={{
                                                            background: 'var(--arc-primary-subtle)',
                                                            color: 'var(--arc-primary-text)',
                                                            padding: '1px 6px',
                                                            borderRadius: '4px',
                                                            fontSize: '0.72rem',
                                                            fontWeight: 600
                                                        }}>
                                                            {isPool ? <><FaSwimmer style={{ marginRight: '3px', fontSize: '0.7rem' }} />{club.personCount} Kulvar</> : <><FaUsers style={{ marginRight: '3px', fontSize: '0.7rem' }} />{club.personCount} Kişi</>}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <span className="appointment-club-status" style={{
                                            padding: '4px 10px',
                                            borderRadius: '9999px',
                                            fontSize: '0.75rem',
                                            fontWeight: 600,
                                            background: paid ? 'var(--arc-success-subtle)' : 'var(--arc-warning-subtle)',
                                            color: paid ? 'var(--arc-success-text)' : 'var(--arc-warning-text)',
                                            border: `1px solid ${paid ? 'rgba(16,185,129,0.25)' : 'rgba(245,158,11,0.25)'}`,
                                            whiteSpace: 'nowrap'
                                        }}>
                                            {paid ? 'Ödendi' : 'Ödenmedi'}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                );
            }

            // Fallback: single club (no clubSlotDetails)
            return (
                <div className="appointment-summary-card" style={{ padding: '16px', background: 'var(--arc-success-subtle)', borderRadius: '12px', border: '1px solid rgba(16, 185, 129, 0.25)', display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '20px', boxShadow: 'var(--arc-shadow-sm)' }}>
                    <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: 'var(--arc-success)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', boxShadow: '0 4px 6px -1px rgba(16, 185, 129, 0.3)' }}>
                        <FaMedal />
                    </div>
                    <div>
                        <div style={{ fontWeight: 700, fontSize: '1.15rem', color: 'var(--arc-success-text)', letterSpacing: '-0.01em', marginBottom: '4px' }}>
                            {appointmentDetail.isTransferred ? (
                                <><FaExchangeAlt style={{ marginRight: '8px', fontSize: '0.9em' }} /> Aktarılan Seans</>
                            ) : (
                                <>{appointmentDetail.firstName} {appointmentDetail.lastName} {(!appointmentDetail.lastName?.includes('Kulüb') && !appointmentDetail.firstName?.includes('Kulüb')) ? 'Kulübü' : ''}</>
                            )}
                        </div>
                        <div style={{ fontSize: '0.85rem', color: 'var(--arc-success-text)', opacity: 0.85, fontWeight: 500 }}>
                            {appointmentDetail.isTransferred ? (
                                <>Orijinal Tarih: {dayjs(appointmentDetail.originalSessionDate).format('DD MMMM YYYY')} - {appointmentDetail.firstName} {appointmentDetail.lastName}</>
                            ) : 'Kulüp Saat Ataması'}
                        </div>
                    </div>
                </div>
            );
        } else if (isBlocked) {
            return (
                <div className="appointment-summary-card" style={{ padding: '16px', background: 'var(--arc-warning-subtle)', borderRadius: '12px', border: '1px solid rgba(245, 158, 11, 0.25)', display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '20px', boxShadow: 'var(--arc-shadow-sm)' }}>
                    <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: 'var(--arc-warning)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', boxShadow: '0 4px 6px -1px rgba(245, 158, 11, 0.3)' }}>
                        <FaBan />
                    </div>
                    <div>
                        <div style={{ fontWeight: 700, fontSize: '1.15rem', color: 'var(--arc-warning-text)', letterSpacing: '-0.01em', marginBottom: '4px' }}>
                            Saat Kapatılmış
                        </div>
                        <div style={{ fontSize: '0.85rem', color: 'var(--arc-warning-text)', opacity: 0.85, fontWeight: 500 }}>
                            {appointmentDetail.blockSource === 'PublicEducation' ? 'Halk Eğitim' :
                                appointmentDetail.blockSource === 'PublicEducationCourse' ? 'Halk Eğitim Kursu' :
                                    appointmentDetail.blockSource === 'Maintenance' ? 'Bakım / Manuel Kapatma' : 'Takvimden Kapatma'}
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="appointment-summary-card" style={{ padding: '16px', background: 'var(--arc-primary-subtle)', borderRadius: '12px', border: '1px solid rgba(37, 99, 235, 0.25)', display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '20px', boxShadow: 'var(--arc-shadow-sm)' }}>
                    <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: 'var(--arc-primary)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', boxShadow: '0 4px 6px -1px rgba(37, 99, 235, 0.3)' }}>
                        <FaUser />
                    </div>
                    <div>
                        <div style={{ fontWeight: 700, fontSize: '1.15rem', color: 'var(--arc-primary-text)', letterSpacing: '-0.01em', marginBottom: '4px' }}>
                            {appointmentDetail.firstName} {appointmentDetail.lastName}
                        </div>
                        <div style={{ fontSize: '0.85rem', color: 'var(--arc-primary-text)', opacity: 0.85, fontWeight: 500 }}>Bireysel Randevu</div>
                    </div>
                </div>
            );
        }
    };

    return (
        <div className="premium-appointment-detail" style={{ fontFamily: "var(--arc-font-sans)" }}>
            <TopCard />

            <div style={{ background: 'var(--arc-surface)', borderRadius: 'var(--arc-radius-lg)', border: '1px solid var(--arc-border)', overflow: 'hidden', boxShadow: 'var(--arc-shadow-sm)' }}>

                {isClub && !appointmentDetail.clubSlotDetails?.length && renderRow('Kulüp Adı', `${appointmentDetail.firstName || ''} ${appointmentDetail.lastName || ''}`.trim(), <FaBuilding />)}
                {isIndividual && renderRow('Ad Soyad', `${appointmentDetail.firstName || ''} ${appointmentDetail.lastName || ''}`.trim(), <FaUser />)}
                {isBlocked && renderRow('Sebep / Kişi', appointmentDetail.sportTypeName || appointmentDetail.lastName || 'Belirtilmemiş', <FaInfoCircle />)}

                {!isClub && renderRow('Vergi No', appointmentDetail.taxNumber, <FaIdCard />)}
                {renderRow('TC Kimlik', appointmentDetail.identityNumber, <FaIdCard />)}
                {renderRow('Cinsiyet', appointmentDetail.userGender === 'Male' ? 'Erkek' : appointmentDetail.userGender === 'Female' ? 'Kadın' : appointmentDetail.userGender === 'Mixed' ? 'Karma' : appointmentDetail.userGender, <FaVenusMars />)}
                {renderRow('Telefon', appointmentDetail.phone, <FaPhone />)}
                {renderRow('E-posta', appointmentDetail.email, <FaEnvelope />)}

                {renderRow('Tesis', appointmentDetail.regionName ? `${appointmentDetail.regionName} / ${appointmentDetail.facilityName}` : appointmentDetail.facilityName, <FaBuilding />, true)}
                {renderRow('Tesis Türü', appointmentDetail.sportTypeName, <FaInfoCircle />)}
                {renderRow('Tarih', appointmentDetail.appointmentDate ? new Date(appointmentDetail.appointmentDate).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' }) : null, <FaCalendarAlt />)}
                {renderRow('Saat', appointmentDetail.startTime ? `${appointmentDetail.startTime} - ${appointmentDetail.endTime}` : null, <FaClock />)}
                {!isClub && appointmentDetail.personCount > 0 && renderRow(
                    isClub ? (isPool ? 'Kulvar Sayısı' : 'Kişi Sayısı') : 'Kişi Sayısı',
                    <span className="appointment-person-count">
                        {isPool ? <FaSwimmer style={{ color: '#0ea5e9' }} /> : <FaUsers style={{ color: '#0ea5e9' }} />}
                        {appointmentDetail.personCount} {isClub ? (isPool ? 'Kulvar' : 'Kişi') : 'Kişi'}
                    </span>,
                    <FaUsers />
                )}
            </div>

            {/* Per-club payment status is now shown in the TopCard for clubs */}
            {(!isBlocked && !isClub && (appointmentDetail.paymentStatus || appointmentDetail.paymentAmount > 0 || appointmentDetail.status === 'Confirmed')) && (
                <div className="appointment-payment-card" style={{ marginTop: '20px', padding: '16px', borderRadius: '12px', border: '1px solid #e2e8f0', background: '#f8fafc', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: '#e2e8f0', color: '#64748b', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem' }}>
                            <FaCreditCard />
                        </div>
                        <div>
                            <div style={{ fontSize: '0.75rem', color: '#64748b', textTransform: 'uppercase', fontWeight: 600, letterSpacing: '0.05em', marginBottom: '2px' }}>Ödeme Durumu</div>
                            <div style={{ fontSize: '1.05rem', fontWeight: 700, color: '#334155' }}>
                                {isFreeFitness ? 'Ücretsiz — seans kullanılmadı' : appointmentDetail.paymentAmount ? `${Number(appointmentDetail.paymentAmount).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} TL` : 'Ücretsiz / Abonelik'}
                            </div>
                        </div>
                    </div>
                    <div>
                        <span style={{
                            padding: '6px 14px', borderRadius: '20px', fontSize: '0.8rem', fontWeight: 600,
                            background: (['AUTH', 'SALE', 'APPROVED'].includes(appointmentDetail.paymentStatus?.toUpperCase()) || appointmentDetail.status === 'Confirmed') ? '#dcfce7' : appointmentDetail.paymentStatus === 'DECLINED' ? '#fee2e2' : '#fef3c7',
                            color: (['AUTH', 'SALE', 'APPROVED'].includes(appointmentDetail.paymentStatus?.toUpperCase()) || appointmentDetail.status === 'Confirmed') ? '#166534' : appointmentDetail.paymentStatus === 'DECLINED' ? '#991b1b' : '#92400e',
                            boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                        }}>
                            {(() => {
                                if (isFreeFitness) return 'ÜCRETSİZ';
                                const ps = appointmentDetail.paymentStatus?.toUpperCase();
                                if (ps === 'APPROVED' || ps === 'AUTH' || ps === 'SALE' || appointmentDetail.status === 'Confirmed') return 'ÖDENDİ / ONAYLI';
                                if (ps === 'DECLINED') return 'REDDEDİLDİ';
                                if (ps === 'PENDING') return 'BEKLİYOR';
                                return 'ÖDENMEDİ';
                            })()}
                        </span>
                    </div>
                </div>
            )}
            {appointmentDetail.createdDate && (
                <div style={{ marginTop: '16px', textAlign: 'center', fontSize: '0.75rem', color: '#94a3b8' }}>
                    Oluşturulma: {new Date(appointmentDetail.createdDate).toLocaleString('tr-TR')}
                </div>
            )}
        </div>
    );
};
export default PremiumAppointmentDetailView;
